import React, { Component } from "react";
import "./common.css";
import { Grid } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import { connect } from "react-redux";
import { validateBegin } from "../actions/validateactions";
import { reportError } from "../actions/erroractions";

class Validate extends Component {
  state = {
    code: "",
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.updateCode = this.updateCode.bind(this);
    this.renderSpinner = this.renderSpinner.bind(this);
    this.renderButton = this.renderButton.bind(this);
  }

  submit() {
    const { code } = this.state;
    const { dispatch, email } = this.props;

    if (isNaN(parseInt(code))) {
      dispatch(reportError("Code must be a number"));
    } else {
      dispatch(validateBegin(email, code));
    }
  }

  updateCode(e) {
    this.setState({
      code: e.target.value,
    });
  }

  renderSpinner() {
    const { loading } = this.props;
    return (
      <Grid item xs={12}>
        <ClipLoader
          color="#FFFFFF"
          sizeUnit={"%"}
          size={100}
          loading={loading}
        />
      </Grid>
    );
  }

  renderButton() {
    return (
      <Grid item xs={12}>
        <button className="bbe-button" onClick={this.submit}>
          Submit
        </button>
      </Grid>
    );
  }

  render() {
    const { loading, validateError } = this.props;

    return (
      <Grid container alignItems="center" justifyContent="center">
        <div className="form login_form">
          <Grid item xs={12}>
            <h2>Validation Code</h2>
          </Grid>
          <Grid item xs={12}>
            <p className="validation_msg">
              Validation code has been sent to your email address.
            </p>
          </Grid>
          <Grid item xs={12}>
            <h4>Code</h4>
          </Grid>
          <Grid item xs={12}>
            <input type="text" className="textbox" onChange={this.updateCode} />
          </Grid>
          <Grid item xs={12}>
            <p>{validateError}</p>
          </Grid>
          {loading ? this.renderSpinner() : this.renderButton()}
        </div>
      </Grid>
    );
  }
}

export const mapStateToProps = (state) => ({
  loading: state.validate.loading,
  validateError: state.validate.validateError,
  email: state.validate.email,
});

export default connect(mapStateToProps)(Validate);
